export { default as getTableItemsAction } from './getTableItemsAction';
export * from './selectionActions';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/table/actions/index.js